import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';

import { KILL_SWITCH_MODE, VIEW_TYPES } from '../shared/utils/constants';
import { selectSettingKillSwitchMode } from '../stores/settings';

@Injectable({
  providedIn: 'root',
})
export class KillSwitchGuard implements CanActivate {
  constructor(private router: Router, private store: Store) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.store.select(selectSettingKillSwitchMode).pipe(
      take(1),
      map((killSwitchMode) => {
        if (killSwitchMode === KILL_SWITCH_MODE.ON) {
          return this.router.createUrlTree([`/${VIEW_TYPES.DEVICE_SUSPENDED}`]);
        }
        return true;
      })
    );
  }
}
